import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import TemplateDto from '../interfaces/TemplateDto'
import Client from '../interfaces/Client'
import { useAuth } from '../hooks/useAuth'
import useTemplateFetcher from '../hooks/useTemplateFetcher'
import useClientFetcher from '../hooks/useClientFetcher'
import useVehicleFetcher from '../hooks/useVehicleFetcher'
import ConsignmentDet from '../interfaces/ConsignmentDet'
import ConsignmentDto from '../interfaces/ConsignmentDto'
import { AppPath } from '../enums/AppPath'
import useConsignmentCrea from '../hooks/useConsignmentCrea'
import VehicleBase from '../interfaces/VehicleBase'
import { DEFAULT_TITLE_CONFIG } from '../utils/documentTitleUtils'

import ConsignmentDetail from './ConsignmentDetail'
import DocConfirma from './DocConfirma'

const ConsignmentPreview: React.FC<{ consign: ConsignmentDto | null; onGoBack: () => void }> = ({
  consign,
  onGoBack,
}) => {
  const { errorConsignmentCrea, consignmentCrea, loading } = useConsignmentCrea()
  const { userData, selectedPair } = useAuth()
  const { errorTemplate, fetchTemplate } = useTemplateFetcher()
  const [template, setTemplate] = useState<TemplateDto | null>(null)
  const { errorClient, fetchClient } = useClientFetcher()
  const [client, setClient] = useState<Client | null>(null)
  const { errorVehicle, fetchVehicleBase } = useVehicleFetcher()
  const [vehicle, setVehicle] = useState<VehicleBase | null>(null)

  const organizationId = userData?.organization?._id ?? ''
  const clientId = selectedPair?.clientId
  const vehicleId = selectedPair?.vehicleId

  useEffect(() => {
    const fetchDataAsync = async () => {
      const data = organizationId ? await fetchTemplate(organizationId, AppPath.Consignments) : null
      setTemplate(data)
    }
    fetchDataAsync()
  }, [organizationId])

  useEffect(() => {
    const fetchDataAsync = async () => {
      const data = clientId ? await fetchClient(clientId) : null
      setClient(data)
    }
    fetchDataAsync()
  }, [clientId])

  useEffect(() => {
    const fetchDataAsync = async () => {
      const data = vehicleId ? await fetchVehicleBase(vehicleId) : null
      setVehicle(data)
    }
    fetchDataAsync()
  }, [vehicleId])

  const navigate = useNavigate()
  // Handle Crear button click
  const handleCrearClick = async () => {
    if (consign === null) return
    const id = await consignmentCrea(consign)

    // refrescamos la pantalla
    if (errorConsignmentCrea) {
      return
    }
    // Si nos va bien, volvemos a la ventana de detalle.

    const url = `/${AppPath.Consignments}/view/${id}`
    navigate(url)
  }

  const vehicleIni = {
    appraisal: 0,
    body: '',
    brand: '',
    chassisId: '',
    color: '',
    comments: '',
    documents: {
      insurance: '',
      checkup: '',
      permit: '',
    },
    engineId: '',

    fuel: '',
    keys: 0,
    maintenance: {
      comments: '',
      status: '',
    },
    model: '',
    odometer: 0,
    owners: 0,
    plate: '',
    price: 0,
    state: '',
    type: '',
    version: '',
    year: 0,
    gearbox: '',
  }
  const finalAddress = client?.address
  const org = template?.general.organization

  // Extract title configuration from template
  const titleConfig = template?.consignments?.title ?? { ...DEFAULT_TITLE_CONFIG }

  const est: ConsignmentDet = {
    titleConfig,
    organization: {
      pictures: org?.pictures ?? { logotype: '', isotype: '' },
      nin: org?.nin?.value ?? '',
      legalName: '',
      name: org?.name.value ?? '',
      business: org?.business.type !== '-' ? (org?.business.value ?? '') : '',
      phone: org?.phone.value ?? '',
      email: org?.email?.value ?? '',
      domain: org?.domain?.value ?? '',
      address: org?.address?.value ?? '',
    },
    client: {
      nin: client?.nin ?? '',
      firstname: `${client?.firstname}`,
      lastname: `${client?.lastname}`,
      phone: client?.phone ?? '',
      email: client?.email ?? '',
      address: finalAddress ?? '',
    },
    vehicle: vehicle ?? vehicleIni,

    price: consign?.price ?? 0,
    notes: consign?.notes ?? '',
    fee: consign?.fee ?? 0,
    charge: consign?.charge ?? 0,
    minimum: consign?.minimum ?? 0,
    city: consign?.city ?? '',
    date: consign?.date ?? '', //new Date(),
    body_first: template?.consignments.body.first.value ?? '',
    body_second: template?.consignments.body.second.value ?? '',

    footer: template?.consignments.footer.value ?? '',
    profile_name: userData?.user?.fullname ?? '',
    paymentShow: consign?.paymentShow ?? false,
    feeIva: consign?.feeIva ?? false,
    carmap: template?.consignments.carmap,
    minimumIva: consign?.minimumIva ?? false,
  }

  return (
    <div className="p-2 max-w-3xl mx-auto">
      <div className="flex justify-center mt-1">
        <button className="bg-blue-500 text-white py-2 px-4 rounded mt-0 mb-2" onClick={onGoBack}>
          Volver a la consignación
        </button>
      </div>
      <ConsignmentDetail consig={est} />
      <DocConfirma docType={AppPath.Consignments} handleCrearClick={handleCrearClick} loading={loading} />
      {errorTemplate && <div>Error: {errorTemplate.message}</div>}
      {errorVehicle && <div>Error: {errorVehicle.message}</div>}
      {errorClient && <div>Error: {errorClient.message}</div>}
    </div>
  )
}

export default ConsignmentPreview
